import React from "react";
import Chart from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import { getCharts } from "../redux/slices/zoho";
import { createPopper } from "@popperjs/core";

const LineChart = () => {
  const dispatch = useDispatch();
  const charts = useSelector((state) => state.zoho.charts);
  let isChartLoading = useSelector((state) => state.zoho.isChartLoading);
  let { forecastNumber, forecastPeriod } = useSelector(
    (state) => state.forecast.forecastInfo
  );

  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  React.useEffect(() => {
    dispatch(getCharts({forecastNumber, forecastPeriod}));
    if(isChartLoading == undefined) {
     isChartLoading = false;
    }


    var config = {
      type: "bar",
      data: {
          labels: isChartLoading ? [] : charts.months,
        datasets: [
          {
            label: 'Inflow',
            backgroundColor: "green",
            borderColor: "green",
           data: isChartLoading ? [] : charts.forecastNairaInflow,
            fill: false,
            barThickness: 15,
            borderWidth: 1,
          },
          {
            label: 'Outflow',
            fill: false,
            backgroundColor: "red",
            borderColor: "red",
            data: isChartLoading ? [] : charts.forecastNairaOutflow,
            barThickness: 15,
         
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: false,
          text: "Sales Charts",
          fontColor: "black",
        },
        legend: {
          labels: {
            fontColor: "black",
          },
          align: "end",
          position: "top",
        },
        tooltips: {
          mode: "index",
          intersect: false,
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontColor: "",
              },
              display: true,
              scaleLabel: {
                display: false,
                scaleType: 'band',
                labelString: "Month",
                fontColor: "black",
              },
              gridLines: {
                display: false,
                borderDash: [2],
                borderDashOffset: [2],
                color: "rgba(33, 37, 41, 0.3)",
                zeroLineColor: "rgba(0, 0, 0, 0)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                fontColor: "black",
              },
              display: true,
              scaleLabel: {
                display: false,
                labelString: "Value",
                fontColor: "black",
              },
              gridLines: {
                borderDash: [2],
                borderDashOffset: [2],
                drawBorder: false,
                color: "rgba(33, 37, 41, 0.2)",
                zeroLineColor: "rgba(33, 37, 41, 0.15)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
        },
      },
    };
    var ctx = document.getElementById("line-chart").getContext("2d");
    window.myLine = new Chart(ctx, config);
  }, []);
  return (
    <>
      <div className="w-full xl:w-10/12 mb-12 xl:mb-0 px-5">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 border rounded ">
          <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
            <div className="flex flex-wrap items-center">
              <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                <h2 className="text-black text-xl font-semibold">
                 Forecast Overview(NGN)
                </h2>
              </div>
            </div>
          </div>
          <div className="py-1 w-full px-2">
                <div className="border-t border-gray-200"></div>
              </div>
          <div className="p-4 flex-auto">
            {/* Chart */}
            <div className="relative" style={{ height: "350px" }}>
              <canvas id="line-chart"></canvas>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LineChart;
